import { ca } from '@cian/analytics';

import { IPageState } from '../../types/page';
import { IFavoriteEntity } from '../../types/results';
import { getAllProducs } from '../../utils/trackings';

export function trackShareFolder(pageData: IPageState, favoriteEntities: IFavoriteEntity[], label: string) {
  const products = getAllProducs({ favoriteEntities });

  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'Click',
    label,
    products,
    page: {
      listingType: 'list',
      pageType: 'ListingFavorites',
      siteType: pageData.deviceType === 'phone' ? 'mobile' : pageData.deviceType,
    },
  });
}
